module.exports = __webpack_public_path__ + "img/blog-16-1.933f47bc.webp";